import React from 'lib/react';
import {
  EVGrid,
  EVButton,
  EVTypography,
  makeStyles,
  EVSearchIcon,
} from 'lib/components';
import PropTypes from 'prop-types';
import TextInputField from 'commonComponents/textInputField';
import SelectField from 'commonComponents/select-field';

const useStyles = makeStyles((theme) => ({
  filterContainer: {
    backgroundColor: theme.evPalette.charcoal[200],
    padding: '16px',
    borderRadius: '4px',
  },
  select: {
    height: '44px',
    backgroundColor: `${theme.evPalette.salt[100]} !important`,
  },
  inputField: {
    height: '44px',
    backgroundColor: `${theme.evPalette.salt[100]} !important`,
    borderRadius: '4px',
    '&> .myev-MuiOutlinedInput-root': {
      height: '100%',
    },
  },
}));

const actionOptions = [
  { id: 'all', description: 'Actions' },
  { id: 'Verify Address', description: 'Verify Address' },
  { id: 'Edit Pitches', description: 'Edit Pitches' },
  { id: 'PV Edit Pitches', description: 'PV Edit Pitches' },
];

function StatefarmFilter({
  onApplyButtonClick,
  onResetButtonClick,
  isApplyButtonDisabled,
  onFilterChange,
  localFilters,
  filteredDataLength,
  totalDataLength,
}) {
  const styles = useStyles();
  return (
    <EVGrid container direction="column">
      <EVTypography variant="body2" style={{ color: '#666', marginBottom: '8px' }}>
        Refine results by choosing filters
      </EVTypography>
      <EVGrid container justifyContent="space-between" alignItems="center" className={styles.filterContainer}>
        <EVGrid item>
          <EVTypography variant="body2">
            {filteredDataLength}
            {' '}
            of
            {' '}
            {totalDataLength}
            {' '}
            records shown
          </EVTypography>
        </EVGrid>
        <EVGrid item container spacing={2} xs={12} md={8} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          <EVGrid item xs={12} sm={3}>
            <TextInputField
              inputId="statefarm-report-id-filter"
              inputFieldProps={{
                InputProps: {
                  endAdornment: <EVSearchIcon htmlColor="#B4BAC7" />,
                  classes: { root: styles.inputField },
                },
                placeholder: 'Enter Report ID',
              }}
              startAdornment={<EVSearchIcon htmlColor="#B4BAC7" />}
              inputValue={localFilters.reportId}
              handleChange={(event) => onFilterChange('reportId', event.target.value)}
            />
          </EVGrid>
          <EVGrid item xs={12} sm={3}>
            <SelectField
              selectId="statefarm-action-filter"
              variant="outlined"
              fullWidth
              selectedValue={localFilters.action}
              handleChange={(event) => onFilterChange('action', event.target.value)}
              className={styles.select}
              selectOptions={actionOptions}
            />
          </EVGrid>
          <EVGrid item xs={12} sm={3}>
            <TextInputField
              inputId="statefarm-email-filter"
              inputFieldProps={{
                InputProps: {
                  endAdornment: <EVSearchIcon htmlColor="#B4BAC7" />,
                  classes: { root: styles.inputField },
                },
                placeholder: 'Enter Email',
              }}
              startAdornment={<EVSearchIcon htmlColor="#B4BAC7" />}
              inputValue={localFilters.email}
              handleChange={(event) => onFilterChange('email', event.target.value)}
            />
          </EVGrid>
          <EVGrid item xs={6} sm="auto">
            <EVButton
              id="statefarm-apply-filter"
              variant="outlined"
              color="primary"
              size="small"
              onClick={onApplyButtonClick}
              disabled={isApplyButtonDisabled}
              style={{ height: '44px' }}
            >
              Apply
            </EVButton>
          </EVGrid>
          <EVGrid item xs={6} sm="auto">
            <EVButton
              id="statefarm-reset-filter"
              color="primary"
              size="small"
              style={{ height: '44px' }}
              onClick={onResetButtonClick}
            >
              Reset
            </EVButton>
          </EVGrid>
        </EVGrid>
      </EVGrid>
    </EVGrid>
  );
}

StatefarmFilter.propTypes = {
  onApplyButtonClick: PropTypes.func.isRequired,
  onResetButtonClick: PropTypes.func.isRequired,
  isApplyButtonDisabled: PropTypes.bool,
  onFilterChange: PropTypes.func.isRequired,
  localFilters: PropTypes.shape({
    action: PropTypes.string,
    reportId: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  filteredDataLength: PropTypes.number.isRequired,
  totalDataLength: PropTypes.number.isRequired,
};

StatefarmFilter.defaultProps = {
  isApplyButtonDisabled: false,
};

export default StatefarmFilter;
